<template>
  <div>
    <h2 class="fw-bold mb-4">Użytkownicy Systemu</h2>
    <p class="text-muted">Lista zarejestrowanych klientów i zarządzanie ich uprawnieniami.</p>
  </div>
</template>

<script>
export default {
  name: 'AdminUsers'
}
</script>